import { LoadingContainer } from 'components/loadingContainer'
import { ShowListUser } from 'features/user/Show'
import { useShowsUser } from 'hooks/user/useShows'

export const ShowListUserPage = () => {
    const { data, isLoading, error } = useShowsUser()

    return (
        <LoadingContainer isLoading={isLoading} error={error}>
            {data && <ShowListUser data={data} />}
        </LoadingContainer>
    )
}
